import ElButton from 'element-plus/es/el-button'

ElButton.props.type.validator = (val) => {
    return [
        'default',
        'link',
        'text',
        'blue',
        'blue_light',
        'blue_white',
        'black',
        'grey',
        'red',
        'transparent'
    ].includes(val);
}
export default ElButton